




import Component from 'vue-class-component';
import { Vue, Inject } from 'vue-property-decorator';

import B2BFooter from '@/components/footer/b2b-footer.vue';
import B2CFooter from '@/components/footer/b2c-footer.vue';
import SurlFooter from '@/components/footer/surl-footer.vue';
import ConfigurationService from '@/shared/service/configuration.service';

@Component({
  components: {
    'b2b-footer': B2BFooter,
    'b2c-footer': B2CFooter,
    'surl-footer': SurlFooter
  }
})
export default class Footer extends Vue {

  @Inject('configurationService')
  private configurationService: () => ConfigurationService;

  get lookupFooterName() {
    return this.configurationService().findComponentNameByLoginQuery(Object.keys(this.$options.components));
  }

}
